// extracted by mini-css-extract-plugin
export default {"FourOffersView":"styles_FourOffersView__buLKf","firstAbsoluteJobOffer":"styles_firstAbsoluteJobOffer__F554G","secondAbsoluteJobOffer":"styles_secondAbsoluteJobOffer__sFL6b"};